<template lang="pug">
    div.pl-md-5.pr-md-5.pb-md-5.width-100-percent.brown.lighten-5(style="margin-top: 0px !important;")
        
        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        template(v-else)
            v-row(dense ref="boxRow")
                v-col.py-3(cols='12')
                    MessageBoxes(
                        :agents="renderAgents"
                    )
            v-row
                v-col.py-0(cols='12')
                    AgentIndex(
                        :agents="renderAgents"
                        :set-current-campaign-customer="setCurrentCampaignCustomer"
                    )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Load components
    import AgentIndex from '@/components/dashboards/live/messages/agent_index.vue';
    import MessageBoxes from '@/components/dashboards/live/messages/message_boxes.vue';

    // Data
    import { GetCampaignCustomerActives } from "@/data";

    export default Vue.extend({
        data() {
            return {
                assignedCampaignCustomerActives: [],
                bus: VolieState.websocketClient().eventBus(),
                isLoading: false,
                renderAgents: [],
            }
        },
        methods: {
            buildRenderAgents() {

                // Reset
                this.renderAgents = [];

                // If we don't have valid agents, abort
                if (!this.validAgents) {
                    return;
                }

                // Init
                const tmpAgents = this.agents.slice();
                if (!(tmpAgents?.length > 0)) {
                    return;
                }

                // Loop through tmp agents and ensure valid
                // NOTE - we used to filter by status type of messages but now show everyone as long as they are logged in
                for (let i = 0; i < tmpAgents.length; i++) {

                    const agent = { ...tmpAgents[i] };
                    if (!agent || !(agent.account_user_id > 0)) {
                        continue;
                    }

                    // Ensure online
                    if (!agent.is_online) {
                        continue;
                    }

                    // Append
                    this.renderAgents.push(agent);
                }

                // If filtered agents is empty, abort
                if (!(this.renderAgents.length > 0)) {
                    return;
                }

                // Fill in assigned cc actives
                if (this.assignedCampaignCustomerActives?.length > 0) {

                    // Sort first
                    const ccActives = this.sortCampaignCustomerActives(this.assignedCampaignCustomerActives.slice(0));
                    if (ccActives?.length > 0) {

                        // Loop through and append to agents
                        for (let i = 0; i < ccActives.length; i++) {

                            // Init clone so we can modify in row render without causing infinite deep watch loop
                            const ccActive = { ...ccActives[i] };
                            if (!(ccActive?.campaign_customer_active_id > 0 && ccActive.assigned_to > 0 && ccActive.account_id > 0)) {
                                continue;
                            }

                            // Loop through render agents and find agent
                            for (let j = 0; j < this.renderAgents.length; j++) {

                                // Init
                                const agent = this.renderAgents[j];

                                // Check if user's match
                                if (!(agent.user_id > 0 && agent.user_id === ccActive.assigned_to && agent.account_id > 0 && agent.account_id === ccActive.account_id)) {
                                    continue;
                                }

                                // Verify present or empty
                                if (!(agent.assigned_campaign_customer_actives?.length > 0)) {
                                    agent.assigned_campaign_customer_actives = [];
                                }

                                // Add to agent's stack
                                agent.assigned_campaign_customer_actives.push(ccActive);
                                break;
                            }
                        }
                    }
                }

                // First sort by user name always
                this.renderAgents = this.sortAgents(this.renderAgents);
            },
            getCampaignCustomerActives() {
                const options = {
                    purpose: "return_message",
                    statuses: ["assigned", "in_progress"],
                }

                this.isLoading = true;
                GetCampaignCustomerActives(options).then((response) => {
                    if (response.Data?.campaign_customer_actives?.length > 0) {
                        this.assignedCampaignCustomerActives = response.Data?.campaign_customer_actives;
                    } else {
                        this.assignedCampaignCustomerActives = [];
                    }

                    this.isLoading = false;
                });
            },
            matchMessageToConversationGroup(message) {

                // Init
                const match = {
                    conversationGroup: null,
                }

                // Verify message
                if (!message || !(message.account_id > 0) || !(message.conversation_group_id > 0) || !(message.conversation_group_person_id > 0) || !(this.assignedCampaignCustomerActives?.length > 0)) {
                    return null;
                }

                // Determine if the customer message belongs to one of the assigned campaign customers
                for (let i = 0; i < this.assignedCampaignCustomerActives.length; i++) {

                    // Init cc
                    const campaignCustomer = this.assignedCampaignCustomerActives[i];

                    // Determine if message's group matches this campaign customer
                    if (campaignCustomer?.campaign_customer_active_id > 0 && campaignCustomer?.conversation_group?.conversation_group_id > 0 && campaignCustomer?.conversation_group?.conversation_group_id === message.conversation_group_id) {
                        match.conversationGroup = campaignCustomer.conversation_group;
                        break;
                    }
                }

                if (match?.conversationGroup?.conversation_group_id > 0) {
                    return match;
                }

                return null;
            },
            onCampaignCustomerActiveStatusChange(response) {

                // Verify legit cc
                const campaignCustomer = response?.Data;
                if (!(campaignCustomer?.campaign_customer_active_id > 0) || !(campaignCustomer?.account_id > 0) || !(campaignCustomer?.purpose?.length > 0) || !(campaignCustomer?.status?.length > 0)) {
                    return;
                }

                // Verify purpose is return message
                if (campaignCustomer.purpose !== "return_message") {
                    return;
                }

                // Find in slice
                const idx = this.assignedCampaignCustomerActives.findIndex(i => i.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id);
                if (idx < 0) {
                    return;
                }

                // Init
                const assigned = this.assignedCampaignCustomerActives[idx];
                if (!assigned) {
                    return;
                }

                // If record is still assigned, update status on record. Otherwise remove from slice (completed, requeued, etc)
                if (campaignCustomer.status === "assigned" || campaignCustomer.status === "in_progress") {
                    assigned.status = campaignCustomer.status;
                } else {
                    this.assignedCampaignCustomerActives.splice(idx, 1);
                }
            },
            onNewAssignedCampaignCustomer(response) {

                // Verify legit cc
                const campaignCustomer = response?.Data;
                if (!(campaignCustomer?.campaign_customer_active_id > 0) || !(campaignCustomer?.account_id > 0) || !(campaignCustomer?.assigned_to > 0) || !(campaignCustomer?.purpose?.length > 0)) {
                    return;
                }

                // Verify purpose is return message
                if (campaignCustomer.purpose !== "return_message") {
                    return;
                }

                // Determine if record already is in array
                const idx = this.assignedCampaignCustomerActives.findIndex(i => i.campaign_customer_active_id === campaignCustomer.campaign_customer_active_id);
                if (idx >= 0) {
                    return;
                }

                // Push onto array
                this.assignedCampaignCustomerActives.push(campaignCustomer);
            },
            onNewMessage(response) {

                // Check if new message is a customer message and that we have assigned campaign customers
                const message = response?.Data;
                if (!message || !(message.account_id > 0) || !(message.message_id > 0) || !(message.conversation_group_id > 0) || (message.personable_type !== "customer_phone_number" && message.personable_type !== "twilio_number")) {
                    return;
                }

                // Match to conversation group using assigned campaign customers
                const match = this.matchMessageToConversationGroup(message);

                // Abort if no matches
                if (!match) {
                    return;
                }

                // If match conversation has a message with an ID greater or equal to the
                // current message then this is a double and we should disregard this message
                if ((match.conversationGroup.last_message_id || 0) >= message.message_id) {
                    return;
                }

                // Set new values on conversation group
                match.conversationGroup.last_conversation_id = message.conversation_id;
                match.conversationGroup.last_message_body = message.body;
                match.conversationGroup.last_message_id = message.message_id;
                match.conversationGroup.last_message_time = message.created_at;
                match.conversationGroup.last_sent_by = message.sent_by;
                match.conversationGroup.unresponded_to_incoming_message_at = message.unresponded_to_incoming_message_at;
                match.conversationGroup.unresponded_to_incoming_message_id = message.unresponded_to_incoming_message_id;

                return;
            },
            setClockValues() {

                // Verify render agents
                if (!(this.renderAgents?.length > 0)) {
                    return;
                }
                
                // Init
                const currentTime = new Date();

                // Loop through agents and set time in seconds
                for (let i = 0; i < this.renderAgents.length; i++) {

                    // Init agent
                    const agent = this.renderAgents[i];
                    if (!agent || !agent.agent_created_at) {
                        continue;
                    }

                    // Init agent time
                    const agentTime = new Date(agent.agent_created_at);

                    // Calculate clock
                    agent.time_in_seconds = (Math.floor(currentTime.getTime() - agentTime.getTime()) / 1000);

                    if (agent?.assigned_campaign_customer_actives?.length > 0) {

                        // Loop through records and set unresponded to time
                        for (let j = 0; j < agent.assigned_campaign_customer_actives.length; j++) {

                            // Init
                            const ccActive = agent.assigned_campaign_customer_actives[j];
                            if (!ccActive || !ccActive.conversation_group) {
                                continue;
                            }

                            // Verify there is an unresponded message
                            if (!!ccActive.conversation_group.unresponded_to_incoming_message_at) {
                                
                                // Init time
                                const unrespondedToTime = new Date(ccActive.conversation_group.unresponded_to_incoming_message_at);
                                if (!!unrespondedToTime) {
                                    ccActive.conversation_group.unresponded_to_time_in_seconds = (Math.floor(currentTime.getTime() - unrespondedToTime.getTime()) / 1000);
                                } else {
                                    ccActive.conversation_group.unresponded_to_time_in_seconds = null;
                                }
                            } else {
                                ccActive.conversation_group.unresponded_to_time_in_seconds = null;
                            }
                        }
                    }
                }
            },
            sortAgents(agents) {
                if (!(!!agents && agents.length > 0)) {
                    return [];
                }

                return agents.sort(function(x, y) {
                    return (x?.user_full_name || "").localeCompare(y?.user_full_name || "");
                });
            },
            sortCampaignCustomerActives(ccActives) {
                if (!(!!ccActives && ccActives.length > 0)) {
                    return [];
                }

                return ccActives.sort(function(x, y) {
                    return x?.campaign_customer_active_id - y?.campaign_customer_active_id;
                });
            },
            startClock() {
                this.clockInterval = setInterval(this.setClockValues, 1000);
            },
            stopClock() {
                if (!this.clockInterval) {
                    return;
                }

                clearInterval(this.clockInterval);
            },
        },
        computed: {
            validAgents() {
                return this.agents?.length > 0;
            },
        },
        components: {
            AgentIndex,
            MessageBoxes,
        },
        props: {
            agents: Array,
            currentBaseDashboardSummary: Object,
            currentDayDashboardSummary: Object,
            setCurrentCampaignCustomer: Function,
        },
        watch: {
            agents: {
                deep: true, // This will let Vue know to look inside the array
                handler() {
                    
                    // Then on next tick, rerender => needs to be this way so the clocks all are re-created at the same time
                    Vue.nextTick(() => { this.buildRenderAgents(); });
                },
            },
            assignedCampaignCustomerActives: {
                deep: true, // This will let Vue know to look inside the array
                handler() {
                    
                    // Then on next tick, rerender => needs to be this way so the clocks all are re-created at the same time
                    Vue.nextTick(() => { this.buildRenderAgents(); });
                },
            },
        },
        destroyed() {
            this.stopClock();
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "campaignCustomerActiveStatusChange" }}, this.onCampaignCustomerActiveStatusChange);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newCustomerAndIncomingPhoneNumberMessage" }}, this.onNewMessage);
        },
        created() {
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "campaignCustomerActiveStatusChange" }}, this.onCampaignCustomerActiveStatusChange);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newCustomerAndIncomingPhoneNumberMessage" }}, this.onNewMessage);
            this.startClock();
            this.buildRenderAgents();
            this.getCampaignCustomerActives();
        },
    });
</script>

<style lang="scss" scoped>
</style>